<ng-content />
<div class="multi-builder-card" [ngClass]="{ 'no-stats': !showStats }">
    <div
        class="scoreboard-container"
        *ngIf="showScoreboardDetails"
        [ngClass]="{ 'set-game-live': isSetGame && isScoreBoardStarted, 'with-stats': showStats }">
        <div class="participants" *ngIf="isSetGame && isScoreBoardStarted; else linkTemplate">
            <ng-container *ngTemplateOutlet="linkTemplate" />
        </div>

        <ms-scoreboard [event]="gridEvent" />
    </div>

    <ms-multi-builder-options
        [optionGroup]="optionGroup"
        [event]="gridEvent"
        [trackingSource]="'MultiBuilder'"
        [showOptionalName]="selectedTab.showOptionName ?? false"
        [showColumn]="selectedTab.showColumnName ?? false" />
    @if (statistics && showStats) {
        <div class="stats-container">
            <ms-last-matches-performance [teamType]="teamType.Home" [statistics]="statistics" [showEventDates]="false" />
            <ms-last-matches-performance [teamType]="teamType.Away" [statistics]="statistics" [showEventDates]="false" />
        </div>
    }
</div>

<ng-template #linkTemplate>
    <div class="participant" *ngFor="let participant of gridEvent.participants; let isLast = last" [title]="participant.name">
        <div class="participant-name">{{ participant.name }}</div>
        <ms-participant-image
            *ngIf="showParticipantImage"
            [participantImage]="participant.image"
            [sportId]="gridEvent.sport.id"
            [showFallback]="false"
            [shouldRotate]="isLast"
            (logoLoaded)="logoLoaded($event)" />
    </div>
</ng-template>
